const TedArrowRightBlue = () => (
  <div>
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.43994 13.2787L10.7866 8.93208C11.2999 8.41875 11.2999 7.57875 10.7866 7.06542L6.43994 2.71875"
        stroke="#2A60DF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedArrowRightBlue;
